// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDI0VHpdfT329DU41s-7Z29AgG2SUfMfJ8",
  // authDomain: "mytalemaker.firebaseapp.com",
  // authDomain:"api.mytalemaker.com",
  // authDomain: "localhost:8787",
  authDomain: new URL(process.env.REACT_APP_BACKEND).host,
  projectId: "mytalemaker",
  storageBucket: "mytalemaker.appspot.com",
  messagingSenderId: "846677126179",
  appId: "1:846677126179:web:e80944707a539cf1055596",
  measurementId: "G-H41QXRK9N8",
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
